import FloorPlanNormalizedDataCore from '../../utils/DrupalEntityTypes/FloorPlan/FloorPlanNormalizedDataCore';

const JSONAPIDeserializer = require( 'jsonapi-serializer' ).Deserializer;

const FloorPlanPrintPageNormalizedData = async ( responseData ) => {
  const options = {
    keyForAttribute: 'camelCase',
  };

  console.log('responseData', responseData);

  const deserializedData = await new JSONAPIDeserializer( options ).deserialize( responseData );
  const included = responseData?.included;
  const deserializedFloorPlan = deserializedData[0];
  const floorPlanData = FloorPlanNormalizedDataCore( deserializedFloorPlan, included );

  const [ communityData ] = deserializedFloorPlan?.ogAudience;

  floorPlanData.community = {
    email: communityData?.fieldEmail,
    phone: communityData?.fieldPhone,
  };

  return floorPlanData;
};

export default FloorPlanPrintPageNormalizedData;
